import { Type } from "class-transformer";
import { isNullOrUndefined } from "@qntm-code/utils";

import { serializeType } from "./common";
import { SolutionManager } from "./solution-manager";

export class DocAttrGroup {
  id?: number;
  version?: number;
  docTypeId: number;
  attributeNameId: number;
  attributeNameName: string;
  attributeNameType: string;
}

export class DocTypeGroup {
  id: number;
  docTypeId: number;
  // transaction: Transaction;
  transaction: string;
  version: number;
}

export class DocType extends SolutionManager {
  enumName: string;
  numberPrefix: string;
  description: string;
  systemDocType?: boolean;
  @Type(serializeType(DocAttrGroup)) attributeGroups: DocAttrGroup[];
  @Type(serializeType(DocTypeGroup)) docTypeGroups: DocTypeGroup[];

  constructor (managingOrgId?: number) {
    super();
    if (!isNullOrUndefined(managingOrgId)) { this.orgId = managingOrgId; }
  }
}
